import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MenuState {
    currentMenuName: string;
    setCurrentMenuName: (menuName: string) => void;
}

export const useMenuStore = create<MenuState>()(
    persist(
        (set) => ({
            currentMenuName: 'Dashboard',
            setCurrentMenuName: (menuName) => set({ currentMenuName: menuName }),
        }),
        {
            name: 'menu-storage',
            partialize: (state) => ({
                currentMenuName: state.currentMenuName,
            }),
        }
    )
);
